import { useState } from "react";
import {Tooltip} from "react-tooltip";
import { useParams } from "react-router-dom";
import {useMedia} from "use-media";
import classNames from "classnames";
import {useAppointment} from "entities/appointment/api/useAppointment";
import {useAppointmentToken} from "entities/appointment/api/useAppointmentToken";
import {NavigationBlocker} from "@features/appointment/blocker-router";
import {AppointmentHeader} from "../appointment-header/appointment-header";
import './livekit.scss'
import s from "./appointment-wrapper.module.scss";
import {TZDate} from "@date-fns/tz";
import {queryClient} from "@shared/api/query-client";
import { AnimatePresence } from "framer-motion";
import { Homeworks } from "../homeworks/homeworks";
import { Notes } from "../notes/notes";
import { ConferenceCard } from "../conference-card/conference-card";
import { AppointmentModals } from "../appointment-modals/appointment-modals";
import { AppointmentContext } from "@widgets/appointment/model/appointment-context/appointment-context";
import { AppointmentNotificationProvider } from "./use-appointment-notification";
import { MobilePlugins } from "@features/appointment/synchronized-audio/ui/mobile-plugins";
import { FloatingRemoteVideo } from "../floating-remote-video/floating-remote-video";


export const AppointmentWrapper = ({
  isTeacher,
}) => {
  return (
    <AppointmentNotificationProvider>
      <AppointmentWrapperContent isTeacher={isTeacher} />
    </AppointmentNotificationProvider>
  );
};

const AppointmentWrapperContent = ({
  isTeacher,
}) => {
	const {data: profile} = queryClient.getQueryData(['profile'])
		
  const { appointmentId } = useParams();
	
  const [mode, setMode] = useState(0);
  const [isConf, setIsConf] = useState(false);
  
  const [isBottomSheetShown, setIsBottomSheetShown] = useState(false);

  const { data: appointment, isFetching: appointmentIsFetching, refetch } = useAppointment(appointmentId, isConf);

  const isMobile = useMedia({ maxWidth: "768px" });
	
  const date = new TZDate(appointment?.starts_at, profile?.timezone);
  const dateEnd = new TZDate(appointment?.ends_at, profile?.timezone);
  const today = new Date();

  const timeToRequest = new Date(date.getTime() - 10 * 60 * 1000);
  const shouldRequest = today >= timeToRequest;
  const confIsEnd = dateEnd?.getTime() < today?.getTime();

  const { data: appointment_token, status } = useAppointmentToken({
    id: appointmentId,
    shouldRequest: shouldRequest && !confIsEnd,
  });

  return (
    <AppointmentContext {...{appointment_token, setIsConf, isConf}}>
			<AppointmentModals/>	

			<NavigationBlocker when={isConf}/>

      <div className={s.flexWrapper}>
        {isMobile && isBottomSheetShown && (
          <div
            onClick={() => setIsBottomSheetShown(false)}
            className={s.overlayBottomSheet}
          ></div>
        )}
        <div
          className={classNames(
            s.appointmentColumn,
            isMobile && isBottomSheetShown && s.shown
          )}
        >
          <AppointmentHeader {...{mode, setMode, appointmentIsFetching, setIsBottomSheetShown, isMobile, refetch, isTeacher}} shown={isBottomSheetShown}  has_unreviewed_homework={appointment?.has_unreviewed_homework} has_new_homework={appointment?.has_new_homework}/>
          {/* Инструменты синхронного аудио: на мобильных живут в шторке материалов */}
          {isMobile && isConf && <MobilePlugins />}
          <div className={s.scrollerContent}>
            <AnimatePresence mode="wait" initial={false}>
              {mode === 0 ? (
								<Notes {...{appointment, appointmentId, isTeacher}}/>
              ) : (
                <Homeworks {...{isTeacher, appointment, appointmentId}}/>
              )}
            </AnimatePresence>
          </div>
          {/* Видео собеседника поверх шторки, пока конференция идёт */}
          {isMobile && isConf && <FloatingRemoteVideo />}
        </div>
        <ConferenceCard {...{appointmentId, appointment, status, isConf, setIsConf, shouldRequest, isTeacher, setMode, setIsBottomSheetShown}}/>
      </div>
      <Tooltip
        id="tooltip-has-new-homework-result"
        content={
          isTeacher
            ? "Есть непроверенное домашнее задание"
            : "Есть невыполненное домашнее задание"
        }
      />
    </AppointmentContext>
  );
};
